import React, { useState } from "react";
import { ReconBillsModal } from "../../pages";
import { BillsController } from "../../controllers";
import constant from "../../utils/constant";
import { MimaToastUtil } from "../../components";
import * as yup from "yup";
import { billsStore } from "../../stores";

const ReconBillsModalContainer = ({ closeModal, billItem }) => {
  const [loading, setLoading] = useState(false);
  const [confirmRecon, setConfirmRecon] = useState(false);

  const validationSchema = () => {
    return yup.object().shape({
      status: yup.string().required("Select Status"),
    });
  };

  const goBack = () => {
    if (confirmRecon) {
      setConfirmRecon(false);
    } else {
      closeModal();
    }
  };

  const statusData = [
    { key: "PAID", value: "PAID" },
    { key: "REVERSED", value: "REVERSED" },
  ];

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      business: billsStore.selectedBill.business._id,
      billReconId: billsStore.selectedBill._id,
      status: values.status,
    };

    const { status, errorMessage } =
      await BillsController.getSpecificBillReconciled(payload);
    if (status === constant.Success) {
      MimaToastUtil.success({ message: "Bill Reconciled successfully" });
      setLoading(false);
      return closeModal();
    } else {
      setLoading(false);
      MimaToastUtil.error({ message: errorMessage });
    }
  };

  return (
    <ReconBillsModal
      loading={loading}
      closeModal={closeModal}
      billItem={billItem}
      confirmRecon={confirmRecon}
      setConfirmRecon={setConfirmRecon}
      goBack={goBack}
      //   reconHandler={reconHandler}
      onSubmit={onSubmit}
      statusData={statusData}
      validationSchema={validationSchema}
    />
  );
};
export default ReconBillsModalContainer;
